import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import MCQTest from "./mcq";
import BasicDetails from "../../recruiter/jobPreview/basic";
import TechnicalInterviewOverview from "../../recruiter/jobPreview/technical";
import { apiGet } from "../../../api/api_methods"; // Adjust the import path as necessary
import HelpCenter from "../../reusble_components/helpCenter";
import HRInterviewOverview from "../../recruiter/jobPreview/HR";
import { useStores } from "../../../store";
import LoadingAnime from "../../reusble_components/loadingAnime";

const JobDetails = () => {
  const { id } = useParams(); // Get the dynamic ID from the URL
  const [jobData, setJobData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { CommonStore, RecuiterStore } = useStores();

  const scrollRef = useRef(null);

  const handleApplyClick = () => {
    try {
      if (scrollRef.current) {
        scrollRef.current.scrollIntoView({ behaviour: "smooth" });
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const fetchJobData = async () => {
      try {
        const response = await apiGet(`/job-post/job-post/${id}`);
        if (response.status === 200 && response.body.success) {
          setJobData(response.body.data);
          RecuiterStore.jobPostDetails.taskDetails =
            response.body.data.assessment;
        } else {
          setError(`Error fetching job data: ${response.body.message}`);
        }
      } catch (error) {
        setError(`Error fetching job data: ${error.message}`);
        console.error("Error fetching job data:", error); // Log the detailed error
      } finally {
        setLoading(false);
      }
    };

    fetchJobData();
  }, [id]);
  const navigate = useNavigate();

  const handleEdit = (id, progress = 0) => {
    CommonStore.setProgress(progress);
    navigate(`/company/job-post?id=${id}&isEdit=true`);
    // alert("1")
  };

  if (loading)
    return (
      <div className="gil-reg">
        <div className="LoadingBox bg-gray-50 p-2">
          <div className="bg-gray-50 rounded-lg max-md:hidden">
            <LoadingAnime
              numBoxes={1} // Correct usage of equal sign to pass a number
              boxWidth="100%" // Use equal sign for strings
              gridColumns="grid-cols-1 sm:grid-cols-1 lg:grid-cols-1" // Correct string prop passing
              bgColor="bg-transparent"
              useShadow={false} // String prop
              page={"basic"}
              innerBoxes={[
                //first text
                {
                  width: "21%",
                  height: "20%",
                  color: "bg-gray-400",
                  shape: "rectangle",
                  top: "0rem",
                  left: "0.3rem",
                },
                {
                  width: "17%",
                  height: "20%",
                  color: "bg-gray-400",
                  shape: "rectangle",
                  top: "-3rem",
                  left: "0.3rem",
                },
                //----------left---------
                {
                  widthMd: "w-[30%]",
                  width: "15%",
                  height: "15%",
                  color: "bg-gray-400",
                  shape: "rectangle",
                  top: "43.2px",
                  left: "0.3rem",
                },
                {
                  width: "15%",
                  height: "15%",
                  color: "bg-gray-400",
                  shape: "rectangle",
                  top: "72px",
                  left: "0.3rem",
                },
                {
                  width: "15%",
                  height: "15%",
                  color: "bg-gray-400",
                  shape: "rectangle",
                  top: "99.2px",
                  left: "0.3rem",
                },
                {
                  width: "15%",
                  height: "15%",
                  color: "bg-gray-400",
                  shape: "rectangle",
                  bottom: "0rem",
                  left: "0.3rem",
                },
                //-----------------------------right------------
                {
                  width: "15%",
                  height: "15%",
                  color: "bg-gray-400",
                  shape: "rectangle",
                  bottom: "0rem",
                  left: "15rem",
                },
                {
                  width: "15%",
                  height: "15%",
                  color: "bg-gray-400",
                  shape: "rectangle",
                  top: "45.2px",
                  left: "15rem",
                },
                {
                  width: "15%",
                  height: "15%",
                  color: "bg-gray-400",
                  shape: "rectangle",
                  top: "72px",
                  left: "15rem",
                },
                {
                  width: "15%",
                  height: "15%",
                  color: "bg-gray-400",
                  shape: "rectangle",
                  top: "99.2px",
                  left: "15rem",
                },

                {
                  width: "15%",
                  height: "78%",
                  color: "bg-gray-400",
                  shape: "rectangle",
                  bottom: "2rem",
                  right: "2rem",
                },
                {
                  width: "100%",
                  height: "2%",
                  color: "bg-gray-400",
                  shape: "rectangle",
                  bottom: "-2rem",
                  right: "0rem",
                },
              ]}
            />
          </div>
          <div className="bg-gray-50 rounded-lg md:hidden">
            <LoadingAnime
              numBoxes={1} // Correct usage of equal sign to pass a number
              boxWidth="100%"
              boxHeight={"22rem"} // Use equal sign for strings
              gridColumns="grid-cols-1 sm:grid-cols-1 lg:grid-cols-1" // Correct string prop passing
              bgColor="bg-transparent"
              useShadow={false} // String prop
              page={"basicMd"}
              innerBoxes={[
                //first text
                {
                  width: "45%",
                  height: "10%",
                  color: "bg-gray-400",
                  shape: "rectangle",
                  top: "4rem",
                  left: "0.3rem",
                },
                {
                  width: "28%",
                  height: "10%",
                  color: "bg-gray-400",
                  shape: "rectangle",
                  top: "0rem",
                  left: "0.3rem",
                },
                //----------left---------
                {
                  width: "0%",
                  height: "7%",
                  color: "bg-gray-400",
                  shape: "rectangle",
                  bottom: "12rem",
                  left: "0.3rem",
                },
                {
                  width: "33%",
                  height: "7%",
                  color: "bg-gray-400",
                  shape: "rectangle",
                  bottom: "10rem",
                  left: "0.3rem",
                },
                {
                  width: "33%",
                  height: "7%",
                  color: "bg-gray-400",
                  shape: "rectangle",
                  bottom: "8rem",
                  left: "0.3rem",
                },

                {
                  width: "33%",
                  height: "7%",
                  color: "bg-gray-400",
                  shape: "rectangle",
                  bottom: "6rem",
                  left: "0.3rem",
                },
                {
                  width: "33%",
                  height: "7%",
                  color: "bg-gray-400",
                  shape: "rectangle",
                  bottom: "4rem",
                  left: "0.3rem",
                },
                {
                  width: "33%",
                  height: "7%",
                  color: "bg-gray-400",
                  shape: "rectangle",
                  bottom: "2rem",
                  left: "0.3rem",
                },
                {
                  width: "33%",
                  height: "7%",
                  color: "bg-gray-400",
                  shape: "rectangle",
                  bottom: "0rem",
                  left: "0.3rem",
                },

                //-----------------------------right------------

                {
                  width: "24%",
                  height: "28%",
                  color: "bg-gray-400",
                  shape: "rectangle",
                  top: "5rem",
                  right: "2rem",
                },
              ]}
            />
          </div>
          <div className="mid">
            {/* Radial charts skeleton */}

            {/* Questions & Answers Section Skeleton */}
            <div className="w-full bg-gray-50 rounded-xl shadow-lg p-[3.5rem] max-md:p-[1.5rem] mt-[2rem]">
              {/* Title Skeleton */}
              <div className="h-6 w-1/3 bg-gray-200 rounded mb-4 shadow-sm"></div>

              {/* Questions and Answers Skeleton */}
              <div className="mb-4">
                <div className="h-4 bg-gray-200 rounded w-3/4 mb-2 shadow-sm"></div>
                <div className="h-4 bg-gray-200 rounded w-full mb-2 shadow-sm"></div>
                <div className="h-4 bg-gray-200 rounded w-1/2 shadow-sm"></div>
              </div>
              <div className="mb-4">
                <div className="h-4 bg-gray-200 rounded w-3/4 mb-2 shadow-sm"></div>
                <div className="h-4 bg-gray-200 rounded w-full mb-2 shadow-sm"></div>
                <div className="h-4 bg-gray-200 rounded w-1/2 shadow-sm"></div>
              </div>

              {/* Behavior Section Skeleton */}
              <div className="mt-6">
                <div className="h-4 bg-gray-200 rounded w-1/4 mb-2 shadow-sm"></div>
                <div className="h-4 bg-gray-200 rounded w-3/4 mb-2 shadow-sm"></div>
                <div className="h-4 bg-gray-200 rounded w-2/4 mb-2 shadow-sm"></div>
              </div>

              {/* Suggestions Section Skeleton */}
              <div className="mt-6">
                <div className="h-6 bg-gray-200 rounded w-1/4 mb-4 shadow-sm"></div>
                <ul>
                  <li className="h-4 bg-gray-200 rounded w-3/4 mb-2 shadow-sm"></li>
                  <li className="h-4 bg-gray-200 rounded w-3/4 mb-2 shadow-sm"></li>
                  <li className="h-4 bg-gray-200 rounded w-3/4 shadow-sm"></li>
                </ul>
              </div>

              {/* Summary Section Skeleton */}
              <div className="mt-6">
                <div className="h-6 bg-gray-200 rounded w-1/4 mb-4 shadow-sm"></div>
                <div className="h-4 bg-gray-200 rounded w-full shadow-sm"></div>
              </div>
            </div>
          </div>
        </div>
        {/* <Loader loader={loading} text={"Fetching job details..."} /> */}
      </div>
    );
  if (error) return <div>{error}</div>;
  if (!jobData) return <div>No job data available</div>;
  const checkSalary = (currency, salary) => {
    if (salary === undefined || salary === null) {
      return "N/A";
    }
    if (currency == "₹") {
      if (salary >= 10000000) return `${(salary / 10000000).toFixed(1)} Cr`; // Crore
      if (salary >= 100000) return `${(salary / 100000).toFixed(1)} L`; // Lakh
      if (salary >= 1000) return `${(salary / 1000).toFixed(0)} K`; // Thousand
    } else if (currency == "$") {
      if (salary >= 1000) return `${(salary / 1000).toFixed(0)} K`; // Thousand
    } else if (currency == "€") {
      if (salary >= 1000000) return `${(salary / 1000000).toFixed(1)} M`; // Million
      if (salary >= 1000) return `${(salary / 1000).toFixed(0)} K`; // Thousand
    } else if (currency == "UGX") {
      if (salary >= 1000000) return `${(salary / 1000000).toFixed(1)} M`; // Million
      if (salary >= 1000) return `${(salary / 1000).toFixed(0)} K`; // Thousand
    }
    return salary;
  };
  const formatsalary = (job) => {
    // const minSalary = checkSalary(jobData?.salary?.minimum);
    // const maxSalary = checkSalary(job?.salary?.maximum);

    // const salary = checkSalary(job?.salary?.exactAmount);
    // const formattedSalary =
    //   minSalary !== "N/A" && maxSalary !== "N/A"
    //     ? job?.salary?.currency?.split[0] ??
    //       "₹" + " " + `${minSalary} - ${maxSalary} ` + job?.salary?.rate
    //     : job?.salary?.currency?.split[0] ??
    //       "₹" + " " + salary + " " + job?.salary?.rate;

    const minSalary = checkSalary(
      job?.salary?.currency?.includes("UGX")
        ? "UGX"
        : job?.salary?.currency?.split(" ")[0] ?? "₹",
      job?.salary?.minimum
    );
    const maxSalary = checkSalary(
      job?.salary?.currency?.includes("UGX")
        ? "UGX"
        : job?.salary?.currency?.split(" ")[0] ?? "₹",
      job?.salary?.maximum
    );

    const salary = checkSalary(
      job?.salary?.currency?.includes("UGX")
        ? "UGX"
        : job?.salary?.currency?.split(" ")[0] ?? "₹",
      job?.salary?.exactAmount ?? job?.salary?.minimum
    );
    // function formatSalary() {
    const formattedSalary =
      minSalary !== "N/A" && maxSalary !== "N/A"
        ? (job?.salary?.currency?.includes("UGX")
            ? "UGX"
            : job?.salary?.currency?.split(" ")[0] ?? "₹") +
          " " +
          `${minSalary} - ${maxSalary} ` +
          job?.salary?.rate.replace("per", "")
        : (job?.salary?.currency?.includes("UGX")
            ? "UGX"
            : job?.salary?.currency?.split(" ")[0] ?? "₹") +
          " " +
          salary +
          "/" +
          (job?.salary?.rate === "perYear"
            ? "Year"
            : job?.salary?.rate === "perMonth"
            ? "Month"
            : job?.salary?.rate === "perDay"
            ? "Day"
            : job?.salary?.rate === "perHour"
            ? "Hour"
            : "");

    return formattedSalary;
  };

  return (
    <>
      <div
        ref={scrollRef}
        className="mx-4 sm:mx-6 md:mx-8 lg:mx-10 my-4 gil-reg"
      >
        <HelpCenter />
        <p className="m-3 opacity-40 text-sm ml-auto">Id: {jobData?._id}</p>

        <div className="shadow-lg rounded-lg pb-5">
          <BasicDetails
            jobId={jobData?._id}
            jobPostId={id}
            jobTitle={jobData?.jobTitle}
            company={jobData?.recruiterId?.companyName}
            isSalaryDisclosed={jobData?.salary?.isSalaryDisclosed}
            salaryRange={
              !jobData?.salary?.minimum &&
              !jobData?.salary?.maximum &&
              !jobData?.salary?.exactAmount
                ? "₹ Not Disclosed"
                : formatsalary(jobData)
            }
            experience={`${
              jobData?.requiredExperience?.minimum < 1 ? " Freshers  / (" : ""
            }  ${jobData?.requiredExperience?.minimum} - ${
              jobData?.requiredExperience?.maximum
            } ${jobData?.requiredExperience?.minimum < 1 ? ") " : ""}`}
            time={jobData?.jobType}
            mode={jobData?.workMode}
            openings={jobData?.noOfOpenings}
            location={jobData?.locations.length > 0 ? [...jobData?.locations] : [jobData?.jobLocation]}
            jobDescription={jobData?.jobDescription}
            responsibilities={jobData?.responsibilities} // Assuming responsibilities is part of jobDescription
            requiredSkills={jobData?.requiredSkills}
            companyLogo={jobData?.recruiterId?.pic}
            qualification={jobData?.qualification}
            noticePeriod={jobData?.noticePeriod}
            showAlert={true}
            onEdit={() => handleEdit(jobData?._id, 0)}
            showApply={true} //for mobile view apply button in the top of the page
            applications={jobData?.applications}
            shortListed={jobData?.shortListed}
            rejected={jobData?.rejected}
            openAt={jobData?.openAt}
            resumeCutoff={jobData?.resumeCutoff ?? 0}
          />
          <MCQTest
            testName={jobData?.mockTest?.mockTestName}
            numberOfQuestions={
              jobData?.mockTest?.noOfTechnicalQuestions +
              jobData?.mockTest?.noOfAptitudeQuestions +
              jobData?.mockTest?.noOfReasoningQuestions +
              jobData?.mockTest?.noOfVerbalQuestions
            }
            onEdit={() => handleEdit(jobData?._id, 1)}
            cutOff={jobData?.mockTest?.cutOff}
          />
          <TechnicalInterviewOverview
            interviewType={jobData?.technicalInterview?.technology}
            interviewLevel={jobData?.technicalInterview?.levelOfInterview}
            numberOfQuestions={jobData?.technicalInterview?.noOfQuestions}
            // showApply={true}
            onEdit={() => handleEdit(jobData?._id, 2)}
            userId={jobData?.recruiterId?._id}
            cutoff={jobData?.technicalInterview?.cutOff ?? "Not Mentioned"}
            // jobPostId={id}
          />
          <HRInterviewOverview
            interviewType={jobData?.hrInterview?.interviewType}
            interviewLevel={jobData?.hrInterview?.levelOfInterview}
            numberOfQuestions={jobData?.hrInterview?.noOfQuestions}
            noOfFollowUps={jobData?.hrInterview?.noOfFollowUps}
            showApply={true}
            onEdit={() => handleEdit(jobData?._id, 3)}
            userId={jobData?.recruiterId?._id}
            jobPostId={id}
            applyClick={handleApplyClick}
            openAt={jobData?.openAt}
            cutOff={jobData?.hrInterview?.cutOff ?? "Not Mentioned"}
            isOpen={jobData?.isOpen}
          />
        </div>
      </div>
    </>
  );
};

export default JobDetails;
